import validate from "/var/www/hotlot/web/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/var/www/hotlot/web/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "sanctum-verified": () => import("/var/www/hotlot/web/middleware/sanctum-verified.ts"),
  "sanctum:auth": () => import("/var/www/hotlot/web/node_modules/nuxt-auth-sanctum/dist/runtime/middleware/sanctum.auth.js"),
  "sanctum:guest": () => import("/var/www/hotlot/web/node_modules/nuxt-auth-sanctum/dist/runtime/middleware/sanctum.guest.js")
}